import React from "react";

// Components
import moment from "moment";
import { useTranslation } from "react-i18next";
import { debug } from "../../App";

export default function DateLastActive({ date }: any) {
  debug("DateLastActive: Rendering", date);
  const { t } = useTranslation();
  const today = moment().startOf("day");
  const yesterday = moment().subtract(1, "day").startOf("day");

  if (!date) {
    return t("never");
  }

  const dateMoment = moment(date);

  if (dateMoment >= today) {
    const fromNow = dateMoment.fromNow();
    if (fromNow === "a few seconds ago") return t("just now");
    return fromNow;
  }
  if (dateMoment >= yesterday) return t("yesterday");
  return <>{dateMoment.format("DD/MM/YYYY")}</>;
}
